import { CommonImage, LinkLabel, NextImage } from '../../../types/CommonVM';
import { HeaderContentEntity } from '../../domain/entities/HeaderContentEntity';

export interface HeaderVmLinks {
  driver_partner_link: LinkLabel;
  support_link: LinkLabel;
  refund_policy_link: LinkLabel;
  terms_of_service_link: LinkLabel;
  for_enterprise_link?: LinkLabel;
  api_integration_link?: LinkLabel;
}

export interface MenuContent {
  close_icon: CommonImage;
  open_icon: CommonImage;
  links: HeaderVmLinks;
}

export interface CompanyContent {
  company_info: string;
  links: HeaderVmLinks;
  location_icon: CommonImage;
}

export interface OpenAppContent {
  app_action: LinkLabel;
  card: { title: string; desc: string; icon: CommonImage };
  close_icon: CommonImage;
}

export interface HeaderVm {
  links: HeaderVmLinks;
  logo: CommonImage;
  menu_content: MenuContent;
  company_content: CompanyContent;
  open_app_content: OpenAppContent;
}

function getLinksVm(data: HeaderContentEntity): HeaderVmLinks {
  return {
    driver_partner_link: data.driver_partner_link,
    support_link: data.support_link,
    refund_policy_link: data.refund_policy_link,
    terms_of_service_link: data.terms_of_service_link,
    for_enterprise_link: data.for_enterprise_link ?? undefined,
    api_integration_link: data.api_integration_link ?? undefined,
  };
}

export function getVm(data: HeaderContentEntity): HeaderVm {
  const links = getLinksVm(data);
  return {
    links,
    logo: data.logo,
    menu_content: {
      close_icon: data.menu_close_icon,
      open_icon: data.menu_open_icon,
      links,
    },
    company_content: {
      company_info: data.company_info,
      links,
      location_icon: data.location_icon,
    },
    open_app_content: {
      app_action: data.open_app_card.app_action,
      card: data.open_app_card.card,
      close_icon: data.menu_close_icon,
    },
  };
}

export function getMenuLinks(
  links: HeaderVmLinks,
  isDom: boolean,
): LinkLabel[] {
  const empty: LinkLabel = { link: '', label: '' };
  return isDom
    ? [
        links.api_integration_link ?? empty,
        links.driver_partner_link,
        links.support_link,
        links.for_enterprise_link ?? empty,
      ]
    : [
        links.support_link,
        links.driver_partner_link,
        links.refund_policy_link,
        links.terms_of_service_link,
      ];
}

export const right_arrow: NextImage = {
  src: 'https://dom-content-vault-prod-cdn-assets.porter.in/chevron_right_black_a88c53ca36/chevron_right_black_a88c53ca36.svg',
  width: 24,
  height: 24,
  alt: 'Right Arrow Icon',
};
